import { saveAs } from 'file-saver'
export function logLengthSorter (logLengthObjectA, logLengthObjectB) {
  return logLengthObjectA.length - logLengthObjectB.length
}

export function downloadExampleImport () {
  const generateExampleString = () => {
    return Array.from(
      { length: MAX_LENGTH - MIN_LENGTH + 1 },
      (_, i) => i + MIN_LENGTH).join(',')
  }
  saveAs(`data:text/csv;charset=utf-8,${generateExampleString()}`,
    'ExampleAccountLogLengths.csv')
}

export const MAX_LENGTH = 64
export const MIN_LENGTH = 6
